import React, { Component } from 'react';
import '../../../../styles/scss/style.css';
import Image from '../../atoms/Image';
import Icon from '../../atoms/Icon';
import Button from '../../atoms/Button';
import FormSelectLanguage from '../../atoms/FormSelectLanguage';
import logoImage from '../../../../images/logo_text_bubble.svg';
import { strings } from './NavigationContent';

//Returning the component
class Navigation extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isNavOpen: this.props.isNavOpen,
		}

		this.clickOutside = this.clickOutside.bind(this);
		this.clickHandler = this.clickHandler.bind(this);
	}
	componentWillMount() {
		// Reads the language from the store
		strings.setLanguage(this.props.language);
	}
	componentWillReceiveProps(nextProps) {
		if (nextProps.language.data !== undefined) {
			strings.setLanguage(nextProps.language.data);
		}
		this.setState({ isNavOpen: nextProps.isNavOpen });
	}
	clickOutside(e) {
		let targetClass = e.target.className;
		// ignore clicks on the component itself
		if (targetClass.includes('navigation__menu') || targetClass.includes('form__select')) {
			return;
		}
		this.clickHandler(e);
	}
	clickHandler(e) {
		if (!this.state.isNavOpen) {
			document.addEventListener('click', this.clickOutside, false);
			this.props.navStatus(true);
		} else {
			document.removeEventListener('click', this.clickOutside, false);
			this.props.navStatus(false);
		}
	}
	render() {
		return (
			<header className="navigation">
				<div className="navigation__container">
					<div className="navigation__logo">
						<a href="/"><Image alt="Frankie Logo" src={logoImage} /></a>
					</div>
					<div className={`navigation__menu ${this.state.isNavOpen ? 'navigation__menu--active' : ''}`}>
						<ul className="menuList">
							<li className="menuList__item">
								<FormSelectLanguage />
							</li>
							<li className="menuList__item"><Button href="/signup" text={strings.buttonTextSignup} /></li>
							<li className="menuList__item"><Button href="/login" text={strings.buttonTextLogin} /></li>
						</ul>
					</div>
				</div>
				<Icon classType={`navigation__hamburger icon fa-2x ${this.state.isNavOpen ? 'fa-close' : 'fa-bars'}`} onClick={this.clickHandler} />
			</header>
		)
	}
}

export default Navigation;


// WEBPACK FOOTER //
// ./src/redux/components/organisms/Navigation/Navigation.jsx